(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["elite-business-construction"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('business-sign-construction')) {
  customElements.define('business-sign-construction', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const details = this.querySelector('details');
      const summary = details.querySelector('summary');
      const mobile = matchMedia('(max-width:999px)');
      const arrange = () => { details.open = !mobile.matches; };
      arrange();
      mobile.addEventListener('change', arrange, options);
      summary.addEventListener('click', event => { if (!mobile.matches) event.preventDefault(); }, options);
      this.addEventListener('shopify:block:select', () => { details.open = true; }, options);
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["elite-color-galaxy-card"] && !Shopify.designMode) return;
  try {
    function positionBusinessGalaxyCard() {
  const home = document.querySelector('[data-business-galaxy-home]');
  const card = document.getElementById('business-sign-colors');
  const actions = document.querySelector('.ebh-top-actions');
  if (!home || !card || !actions) return;
  const desktop = window.matchMedia('(min-width:1000px)');
  const place = () => {
    const sidebar = desktop.matches;
    (sidebar ? actions.parentElement : home).appendChild(card);
    card.classList.toggle('ecgl--sidebar', sidebar);
  };
  place();
  desktop.addEventListener('change', place);
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', positionBusinessGalaxyCard, {once:true});
else positionBusinessGalaxyCard();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["em-theme-browser"] && !Shopify.designMode) return;
  try {
    (() => {
  function close(nav, restoreFocus = false) {
    nav.classList.remove('is-expanded');
    const toggle = nav.querySelector('[data-em-theme-toggle]');
    toggle.setAttribute('aria-expanded', 'false');
    nav.querySelector('.em-universe__panel').hidden = true;
    if (restoreFocus) toggle.focus();
  }
  function closeSwitcher(switcher, restoreFocus = false) {
    switcher.classList.remove('is-expanded');
    const toggle = switcher.querySelector('[data-em-switcher-toggle]');
    toggle.setAttribute('aria-expanded', 'false');
    switcher.querySelector('.em-collection-switcher__panel').hidden = true;
    if (restoreFocus) toggle.focus();
  }
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const switcherToggle = event.target.closest('[data-em-switcher-toggle]');
    if (switcherToggle) {
      const switcher = switcherToggle.closest('.em-collection-switcher');
      const expanded = switcherToggle.getAttribute('aria-expanded') !== 'true';
      document.querySelectorAll('.em-universe.is-expanded').forEach(nav => close(nav));
      document.querySelectorAll('.em-collection-switcher.is-expanded').forEach(other => closeSwitcher(other));
      switcher.classList.toggle('is-expanded', expanded);
      switcherToggle.setAttribute('aria-expanded', String(expanded));
      switcher.querySelector('.em-collection-switcher__panel').hidden = !expanded;
      return;
    }
    const switcherClose = event.target.closest('[data-em-switcher-close]');
    if (switcherClose) {
      closeSwitcher(switcherClose.closest('.em-collection-switcher'), true);
      return;
    }
    document.querySelectorAll('.em-collection-switcher.is-expanded').forEach(switcher => {
      if (!switcher.contains(event.target) || event.target.closest('a')) closeSwitcher(switcher);
    });
    const closeButton = event.target.closest('[data-em-theme-close]');
    if (closeButton) {
      close(closeButton.closest('.em-universe'), true);
      return;
    }
    const toggle = event.target.closest('[data-em-theme-toggle]');
    if (toggle) {
      const nav = toggle.closest('.em-universe');
      const expanded = toggle.getAttribute('aria-expanded') !== 'true';
      document.querySelectorAll('.em-universe.is-expanded').forEach(other => close(other));
      nav.classList.toggle('is-expanded', expanded);
      toggle.setAttribute('aria-expanded', String(expanded));
      nav.querySelector('.em-universe__panel').hidden = !expanded;
      return;
    }
    document.querySelectorAll('.em-universe.is-expanded').forEach(nav => {
      if (!nav.contains(event.target) || event.target.closest('a')) close(nav);
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      document.querySelectorAll('.em-universe.is-expanded').forEach(nav => close(nav, true));
      document.querySelectorAll('.em-collection-switcher.is-expanded').forEach(switcher => closeSwitcher(switcher, true));
    }
  });
  document.addEventListener('focusin', event => {
    document.querySelectorAll('.em-collection-switcher.is-expanded').forEach(switcher => {
      if (!switcher.contains(event.target)) closeSwitcher(switcher);
    });
    document.querySelectorAll('.em-universe.is-expanded').forEach(nav => {
      if (!nav.contains(event.target)) close(nav);
    });
  });
  window.addEventListener('pageshow', () => {
    document.querySelectorAll('.em-collection-switcher.is-expanded').forEach(switcher => closeSwitcher(switcher));
    document.querySelectorAll('.em-universe.is-expanded').forEach(nav => close(nav));
  });
})();
  } catch(e) { console.error(e); }
})();

})();
